/**
 * Created by shani on 03/07/17.
 */

import { GuestUserDTO } from '../models/dto/user-guest';
import { B2CUserDTO } from '../models/dto/user-b2c';
import { B2BMasterUserDTO } from '../models/dto/user-b2b-master';
import { B2BSubUserDTO } from '../models/dto/user-b2b-sub';
import { UserEntityTypes } from './user-entity-types';

declare let _: any;

// @dynamic
export class UserFactory {

    public static create(attributes: object) {
        if (_.isEmpty(attributes) || _.isEmpty(attributes['entity_type'])) {
            return new GuestUserDTO(attributes);
        }
        switch (attributes['entity_type']) {
            case UserEntityTypes.LABEL_B2C:
                return new B2CUserDTO(attributes);
            case UserEntityTypes.LABEL_B2B_MASTER:
                return new B2BMasterUserDTO(attributes);
            case UserEntityTypes.LABEL_B2B_SUB:
                return new B2BSubUserDTO(attributes);
            default:
                return new GuestUserDTO(attributes);
        }
    }

}
